/* eslint-disable camelcase */
import { useState } from 'react'

import { getCheckoutSessionURL } from '@/api/billing'
import { useToast } from '@/components/Toast/ToastContext'
import { useAnalytics } from '@/hooks/useAnalytics'
import { usePricing } from '@/hooks/usePricing'
import { PaymentSchedule, PlanType } from '@/types'
import { EventName, PLATFORM_ADMIN_PORTAL } from '@/utils/eventDefinitions'
import { PLAN_REF } from '@/utils/subscription'

type Status = 'ready' | 'loading' | 'error'

export const useCheckoutSession = () => {
  const [status, setStatus] = useState<Status>('ready')
  const { updateToast } = useToast()
  const { currency } = usePricing()
  const { trackEvent } = useAnalytics()

  const createCheckoutSession = async (planId: PlanType, schedule: PaymentSchedule) => {
    const plan = PLAN_REF[planId][schedule]

    setStatus('loading')
    try {
      localStorage.setItem('awaiting-stripe-subscription', 'true')
      const { data } = await getCheckoutSessionURL({ plan, seats: 3, add_billing_info: true, currency })
      trackEvent?.(EventName.CheckoutStarted, {
        source: 'payment_page',
        platform: PLATFORM_ADMIN_PORTAL,
        isTeam: true,
        plan_id: planId,
        schedule,
      })
      window.location.href = data.url
    } catch (err) {
      console.error('Failed to get session', err)
      updateToast('Failed to connect to Stripe', 'error')
      setStatus('error')
    }
  }

  return {
    status,
    createCheckoutSession,
  }
}
